import { RenderTreeNodePayload, Group, Checkbox } from "@mantine/core"
import { IconChevronDown } from "@tabler/icons-react"

export function defaultNodeRenderer({
  node,
  expanded,
  hasChildren,
  elementProps,
  tree,
}: RenderTreeNodePayload) {
  const checked = tree.isNodeChecked(node.value)
  const indeterminate = tree.isNodeIndeterminate(node.value)

  return (
    <Group gap="xs" {...elementProps}>
      <Checkbox.Indicator
        checked={checked}
        indeterminate={indeterminate}
        onClick={() =>
          !checked ? tree.checkNode(node.value) : tree.uncheckNode(node.value)
        }
      />

      <Group
        gap={5}
        onClick={() =>
          hasChildren
            ? tree.toggleExpanded(node.value)
            : !checked
              ? tree.checkNode(node.value)
              : tree.uncheckNode(node.value)
        }
      >
        <span>{node.label}</span>

        {hasChildren && (
          <IconChevronDown
            size={14}
            style={{ transform: expanded ? "rotate(180deg)" : "rotate(0deg)" }}
          />
        )}
      </Group>
    </Group>
  )
}
